import { environment } from '../environments/environment';

/**
 * Helper function to build the URL for calling Datanex backend.
 *
 * @param {string} subDir - the sub-directory of the URL without the trailing slash.
 */
export const urlBuilder = (subDir: string) => {
  return `${environment.API_BASE_URL}${subDir}`;
};
